var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "url(#paint0_linear_4694_239666)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0889 9H24.8032L18.8733 15.7774L25.8493 25H20.3872L16.109 19.4066L11.2138 25H8.49798L14.8405 17.7508L8.14844 9H13.7492L17.6163 14.1126L22.0889 9ZM21.1363 23.3754H22.6403L12.932 10.5393H11.3181L21.1363 23.3754Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4694_239666",
    x1: 0,
    y1: 17,
    x2: 34,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.468808784ea04365783c4fedbb728301.svg";
export { ForwardRef as ReactComponent };